import one from "./1.jpg";
import two from "./2.jpg";
import three from "./3.jpg";
import four from "./4.jpg";
import five from "./5.jpg";

import seven from "./7.jpg";
import eight from "./8.jpg";
import nine from "./9.jpg";
import ten from "./10.jpg";
import eleven from "./11.jpg";
import twelve from "./12.jpg";

const homeBannerImages = [
  one,
  two,
  three,
  four,
  five,

  seven,
  eight,
  nine,
  ten,
  eleven,
  twelve,
];

export default homeBannerImages;
